import React, { useState } from 'react';
import InputRadio from './InputRadio';
import { IoMdInformationCircleOutline } from 'react-icons/io';

export default function InputGroupRadio({
  label,
  options,
  error,
  touched,
  name,
  className,
  setFieldValue,
  labelClassName,
  value,
  description,
  optionDirection = 'row',
  helperTextTitle,
  helperTextDescription,
  ...props
}) {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <div role="group" className={`my-2 ${className}`}>
      {label && (
        <div className="flex items-center gap-2">
          {(helperTextTitle || helperTextDescription) && (
            <button
              type="button"
              onClick={() => setShowPopup(true)}
              className="text-gray-500 hover:text-gray-700 focus:outline-none"
              aria-label="Show info">
              <IoMdInformationCircleOutline className="text-lg" />
            </button>
          )}
          <label className={`text-lg ${labelClassName}`}>{label}</label>
        </div>
      )}
      {description && <p>{description}</p>}
      <div
        className={`mt-2 flex gap-6 flex-wrap ${
          optionDirection === 'row' ? 'flex-row items-center' : 'flex-col items-start'
        }`}>
        {options?.length &&
          options?.map((option, i) => (
            <InputRadio
              checked={value?.value === option.value}
              value={value}
              key={i}
              name={name}
              col={optionDirection === 'col'}
              {...option}
              {...props}
              onChange={() => {
                setFieldValue(name, option, true);
              }}
            />
          ))}
      </div>
      {error && touched && <p className="text text-red-500">{error}</p>}
      <HelperTextPopup
        data={{ title: helperTextTitle, description: helperTextDescription }}
        showPopup={showPopup}
        setShowPopup={setShowPopup}
      />
    </div>
  );
}

const HelperTextPopup = ({ data, showPopup, setShowPopup }) => {
  if (!showPopup) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      onClick={() => setShowPopup(false)}>
      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-60" />
      {/* Popup */}
      <div
        className="relative mx-4 bg-white rounded-2xl shadow-xl max-w-md w-full p-8"
        onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button
          type="button"
          aria-label="Close"
          className="absolute top-4 right-4 text-2xl text-black hover:text-gray-700 font-bold"
          onClick={() => setShowPopup(false)}>
          ×
        </button>
        {/* Content */}
        <div
          className="text-center font-bold mb-5"
          dangerouslySetInnerHTML={{ __html: data.title }}
        />
        <div className="text-center" dangerouslySetInnerHTML={{ __html: data.description }} />
      </div>
    </div>
  );
};
